<script lang="ts">
import { onMounted } from 'vue';

import { useChat } from '@/stores/chat';
import { BuilderComponent } from '@/utils/cms';

export const ChatNowRegistration: BuilderComponent = {
  name: 'Chat Now',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Chat CTA text here' } },
    },
  ],
};
</script>

<script setup lang="ts">
const chat = useChat();
onMounted(chat.init);
</script>

<template>
  <div v-if="chat.available" class="flex flex-col items-center cursor-pointer" @click="chat.open">
    <slot />
  </div>
  <a v-else href="mailto:help@nuts.com" class="flex flex-col items-center cursor-pointer">
    <span class="w-0 h-0">Mailto link</span>
    <slot />
  </a>
</template>
